module.exports = __webpack_public_path__ + "iconfont.woff?055eb59d253682bf5544443dab9054ea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.woff?t=1612683013658
// module id = 14
// module chunks = 0